import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import TableTab1 from "./TableTab1";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import {
  usePaymentTermListMutation,
} from "../../../../store/api/itemapi";
const Tab1 = ({
  IdData,
  TemplateName,
  AllocatePaymentBasedOnPaymentTerms,
  setselected_payment_term_data,
  selected_payment_term_data,
  list_payment_term_data,
}) => {
  const [PaymentTermApi] = usePaymentTermListMutation();

  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-4" style={{
          width: "290px",
        }}>
          <div className="mb-3">
            <Input
              id="TemplateName"
              label="Template Name"
              style={{
                height: "30px",
                border: TemplateName.Error ? "1px solid red" : "",
              }}
              value={TemplateName.TemplateName}
              readOnly
            />

          </div>
        </div>
        <div className="col-8">
          <div className="mb-3">

            <Checkbox
              id="AllocatePaymentBasedOnPaymentTerms"
              label="Allocate Payment Based On Payment Terms"
              value={AllocatePaymentBasedOnPaymentTerms?.AllocatePaymentBasedOnPaymentTerms || false}
              onChange={(val) => AllocatePaymentBasedOnPaymentTerms?.setAllocatePaymentBasedOnPaymentTerms?.(val)}
            />
            <div style={{ fontSize: "9px", color: "#00000099", marginLeft: '23px' }}>
              If this checkbox is checked, paid amount will be splitted and allocated as per the amounts in payment schedule against each payment term
            </div>
          </div>
        </div>

      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Payment Terms </p>
        </div>

        <TableTab1 setselected_payment_term_data={setselected_payment_term_data} list_payment_term_data={PaymentTermApi} selected_payment_term_data={selected_payment_term_data} />

      </div>
      <div className="">
        <ActivityCard doctype="Payment Terms Template" docname={IdData} />
      </div>
    </>
  );
};

export default Tab1;
